<template>
  <div class="box-tab">
    <div id="accordion">  
      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#details1">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRESS3UC3']['0'] }}
          </h3>
        </div>
        <div id="details1" class="panel-collapse collapse in tab-detail">
          <div class="panel-body">
            <div class="detail detail-responsive">
              <div class="detail-block">
        
                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRESS3UC3']['20'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="coddesc_codempid" name="coddesc_codempid">{{ detail.tab1.detail.codempid }} - {{ detail.tab1.detail.desc_codempid }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRESS3UC3']['30'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70">{{ detail.tab1.detail.codpfinf }} - {{ detail.tab1.detail.desc_codpfinf }}
                      </div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRESS3UC3']['40'] }}</div>
                  <div class="detail-right">
                       <div class="detail-text width-70" id="nummember" name="nummember">{{ detail.tab1.detail.nummember }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRESS3UC3']['50'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="dteeffec" name="dteeffec">{{ setDateOutput(detail.tab1.detail.dteeffec) }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRESS3UC3']['90'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="dtereti" name="dtereti">{{ setDateOutput(detail.tab1.detail.dtereti) }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRESS3UC3']['60'] }}</div>
                  <div class="detail-right">
                      <input type="radio" value="1" v-model="detail.tab1.detail.flgemp" disabled="disabled" /> <span class="radio-text">{{ labels['HRESS3UC3']['70'] }}</span>
                      <input type="radio" value="2" v-model="detail.tab1.detail.flgemp" disabled="disabled" /> <span class="radio-text">{{ labels['HRESS3UC3']['80'] }}</span>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRESS3UC3']['100'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text txtarea-width width-70" id="remark" name="remark">{{ detail.tab1.detail.remark }}</div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRESS3UC3']['110'] }}</div>
                  <div class="detail-right">
                      <div class="input-group width-70">
                          <input type="text" class="form-control input-text" id="ratereta" name="ratereta" disabled="disabled" v-model="detail.tab1.detail.ratereta" />
                          <div class="input-group-addon input-group-addon-cust">%</div>
                      </div>
                  </div>
                </div>

                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRESS3UC3']['120'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="dtechg" name="dtechg">{{ setDateOutput(detail.tab1.detail.dtechg) }}</div>
                  </div>
                </div>
              </div>

              <div class="detail detail-responsive">
               <div class="col-md-12">
                    <div class="detail-header"><u>{{ labels['HRESS3UC3']['140'] }}</u></div>
                </div>
                <div class="clearfix detail-row">
                  <div class="detail-left label-left">{{ labels['HRESS3UC3']['120'] }}</div>
                  <div class="detail-right">
                      <div class="detail-text width-70" id="dteplann" name="dteplann">{{ detail.tab1.detail.dteplann }}</div>
                  </div>
                </div>
              </div>

              <hrms-table :columns="tab1Table" :data="detail.tab1.table" :summaryLabel="labels['HRESS3UC3']['190']"/>        

            </div>
          </div>
        </div>
      </div>

      <div class="panel box-collapse border-color-skin">
        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion" href="#details2">
          <h3 class="box-title">
            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRESS3UC4']['0'] }}
          </h3>
        </div>
        <div id="details2" class="panel-collapse collapse tab-detail">
          <div class="panel-body">
            <div class="detail detail-responsive panel-detail-filter">

              <hrms-table :columns="tab2Table" :data="detail.tab2.table" />      

            </div>
          </div>
        </div>
      </div>

    </div> 

    <div class="box-footer">  
        <button type="button" class="btn bg-dark-gray" @click="toggle('index')" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>   
    </div>

  </div>
</template>

<script>
import assetsUtils from 'assets/js/utils'
export default {
  name: 'hress3u-detail',
  props: [ 'labels', 'labelsButton', 'detail', 'toggle', 'data', 'nowLang', 'tab1Table', 'tab2Table' ],
  methods: {
    setDateOutput (date) {
      return assetsUtils.getDateOutput(date)
    }
  }
}
</script>



// WEBPACK FOOTER //
// detail.vue?529f9c06